import React from 'react'
import DropdownMenu from '~/Common-Objects/UI/DropdownMenu'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import * as styles from './index.module.scss'
import i18n from '~/i18n'

export default function InboxStatusDropdownMenu({
    conversationsStatusFilter = 'unassigned',
    setConversationsStatusFilter = () => {},
    activeInbox = { name: '', unassignedChats: 0, mineChats: 0, assignedChats: 0 },
    disabled = false,
    aiEnabled = false,
    stats
}) {
    let statusCount
    const _stats = stats || activeInbox.stats || {}
    if (conversationsStatusFilter == 'unassigned') statusCount = _stats.unassignedChats || 0
    if (conversationsStatusFilter == 'mine') statusCount = _stats.mineChats || 0
    if (conversationsStatusFilter == 'assigned') statusCount = _stats.assignedChats || 0
    if (conversationsStatusFilter == 'ai') statusCount = _stats.aiChats || 0
    if (conversationsStatusFilter == 'closed') statusCount = _stats.closedChats || 0
    if (conversationsStatusFilter == 'spam') statusCount = _stats.spamChats || 0

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger disabled={disabled} variant='ghost' size='s' className={styles.trigger}>
                {statusCount > 0 ? statusCount : ''}{' '}
                <span style={{ textTransform: 'capitalize' }}>{conversationsStatusFilter}</span>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
                <DropdownMenu.Content align='start'>
                    <DropdownMenu.Label>
                        {i18n.t('chat:inbox.leftBar.statusDropdown.status')}
                    </DropdownMenu.Label>

                    <DropdownMenu.RadioGroup
                        value={conversationsStatusFilter}
                        onValueChange={setConversationsStatusFilter}
                    >
                        <DropdownMenu.RadioItem value='unassigned'>
                            {i18n.t('chat:inbox.leftBar.statusDropdown.unassigned')}{' '}
                            {_stats.unassignedChats > 0 && (
                                <SquareChip>{_stats.unassignedChats}</SquareChip>
                            )}
                        </DropdownMenu.RadioItem>

                        <DropdownMenu.RadioItem value='mine'>
                            {i18n.t('chat:inbox.leftBar.statusDropdown.mine')}{' '}
                            {_stats.mineChats > 0 && <SquareChip>{_stats.mineChats}</SquareChip>}
                        </DropdownMenu.RadioItem>

                        <DropdownMenu.RadioItem value='assigned'>
                            {i18n.t('chat:inbox.leftBar.statusDropdown.assigned')}{' '}
                            {_stats.assignedChats > 0 && <SquareChip>{_stats.assignedChats}</SquareChip>}
                        </DropdownMenu.RadioItem>

                        {aiEnabled && (
                            <DropdownMenu.RadioItem value='ai'>
                                {i18n.t('chat:inbox.leftBar.statusDropdown.ai')}{' '}
                                {_stats.aiChats > 0 && <SquareChip>{_stats.aiChats}</SquareChip>}
                            </DropdownMenu.RadioItem>
                        )}

                        <DropdownMenu.RadioItem value='closed'>
                            {i18n.t('chat:inbox.leftBar.statusDropdown.closed')}{' '}
                            {_stats.closedChats > 0 && <SquareChip>{_stats.closedChats}</SquareChip>}
                        </DropdownMenu.RadioItem>

                        <DropdownMenu.RadioItem value='spam'>
                            {i18n.t('chat:inbox.leftBar.statusDropdown.spam')}{' '}
                            {_stats.spamChats > 0 && <SquareChip>{_stats.spamChats}</SquareChip>}
                        </DropdownMenu.RadioItem>
                    </DropdownMenu.RadioGroup>
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    )
}
